import React from 'react';
import { findFileByText } from '@Helper/FolderHelper';
import { FileItemProps } from '../FileItem/FileItem.component';
import FileListView, { FileListProps } from '../FileListView/FileListView.component';

type SearchedFileListProps = {
  listType: string;
  searchText: string;
  sourcePath: FileItemProps[];
  fileListProps: FileListProps
}

const SearchedFileList = ({
  listType,
  searchText,
  sourcePath,
  fileListProps
}: SearchedFileListProps) => {
  const file = findFileByText(searchText, sourcePath);
  const mapFileName = (file: FileItemProps): FileItemProps => {
    const { name } = file;
    const text = searchText.toLocaleLowerCase(); 
    const startIndex = name.toLocaleLowerCase().indexOf(text);
    const htmlName = `${name.substring(0, startIndex)}<span style="background-color: yellow;">${name.substring(startIndex, (text.length + startIndex))}</span>${name.substring(text.length + startIndex, name.length)}`;
    return {...file, htmlName};
  };

  return (
    <FileListView fileList={file.files.map(mapFileName)} fileListProps={fileListProps} listType={listType}/>
  )
}

export default SearchedFileList;
